import {EnumFilter} from "@/lib/store/state/filters/EnumFilter";

export class TransactionTypeFilter extends EnumFilter {
    public defaultValue: string = null;
    public defaultText: string = "Transaction Type";
}
